import _ from 'lodash';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  Modal,
  ModalBody,
  ModalHeader,
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';
import NumberFormat from 'react-number-format';
import OneClickButton from '../form/button';
import addNotification from '../notification';
import Table from '../table/Table';
import Form from '../form/form';
import { printFractionalPackagingLabel } from '../../app/store/actions/labels';
import { getUserPrinterOptions } from '../../app/store/actions/printers';
import { PanelPage } from '../pages/pages';
import { getOptionsProductsLimit } from '../../app/store/actions/products';
import FormatHelpers from '../../helpers/format';
import { getListInboundOrderProducts } from '../../app/store/actions/inboundOrders';
import { getListOutboundOrderProducts } from '../../app/store/actions/outboundOrders';

class PrintFractionalPackagingLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultPageSize: 3,
      pageSizeOptions: [3, 4, 5],
      totalSelected: 0,
      qtdLabelsToPrint: 1,
      qtdFractionalPackaging: 1,
      labelsToPrint: [],
      showModalDelete: false,
      labelToPrintDelete: null,
      printerOptions: [],
      showPrinterDialog: false,
      printerSelected: null,
      listProduct: [],
      productCode: '',
      productName: '',
      unitMeasure: '',
      materialFamily: '',
      showProductForm: true,
      showQuantitiesForm: false,
      checked: {},
      checkedLabelsToPrintIds: [],
      orderNumber: '',
      documentProducts: [],
    };

    this.tableColumns = this.getTableColumns();
  }

  async componentDidMount() {
    this.setFormInitState();
    this.setFormModeState();
    this.getFormData();
    this.getUserPrinterOptions();
  }

  async componentWillUnmount() {
    this.setInitState();
    this.setFormInitState();
  }

  setInitState = () => {
    this.setState({
      checked: {},
      checkedLabelsToPrintIds: [],
      listProduct: [],
      productCode: '',
      productName: '',
      unitMeasure: '',
      materialFamily: '',
      orderNumber: '',
      documentProducts: [],
    });
    this.setFormModeState();
  };

  setFormInitState = () => {
    this.setState({
      showModalDelete: false,
      labelToPrintDelete: null,
      qtdLabelsToPrint: 1,
      qtdFractionalPackaging: 1,
    });
  };

  setFormModeState = () => {
    if (this.props.modalMode) {
      if (this.props.inboundOrder || this.props.outboundOrder) {
        this.setState({
          showProductForm: false,
          showQuantitiesForm: false,
        });
      } else {
        this.setState({
          showProductForm: false,
          showQuantitiesForm: true,
        });
      }
    } else {
      this.setState({
        showProductForm: true,
        showQuantitiesForm: false,
      });
    }
  };

  setValue = (field, value) => {
    this.setState({ [field]: value });
  };

  setValueDrop = async (attr, value) => {
    this.setState({
      [`${attr}Code`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  setFilterDrop = _.debounce(async (attr, value) => {
    const {
      productCode,
    } = this.state;

    if (productCode === value) {
      return;
    }

    const { products } = await this.props.getOptionsProductsLimit(value);

    const dataSelected = products
      ? products.filter((item) => item.value === value)
      : [];

    if (dataSelected.length === 1) {
      const selectedProduct = dataSelected[0];
      this.setState({
        [`${attr}Code`]: selectedProduct.value ? selectedProduct.value : null,
        [`${attr}Name`]: selectedProduct.value ? selectedProduct.label : '',
        unitMeasure: selectedProduct.unitMeasure || '',
        materialFamily: selectedProduct.materialFamily || '',
        showQuantitiesForm: true,
      });
    } else {
      this.setState({
        [`${attr}Code`]: null,
        [`${attr}Name`]: '',
        unitMeasure: '',
        materialFamily: '',
      });
    }

    this.setState({
      listProduct: products,
    });
  }, 1000);

  getTableColumns = () => {
    const { modalMode } = this.props;
    const columns = [{
      Header: I18n.t('BEE55' /* Ações */),
      accessor: 'action',
      style: { overflow: 'visible', alignSelf: 'center' },
      filterable: false,
      sortable: false,
      width: 100,
      Cell: (rows) => (
        <div style={{ textAlign: 'center' }}>
          <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
          <UncontrolledButtonDropdown>
            <DropdownToggle color="default" caret className="btn-xs" />
            <DropdownMenu>
              <DropdownItem onClick={() => this.showDeleteLabelToPrint(rows.row)}>
                {I18n.t('BEE81' /* Eliminar */)}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      ),
    },
    {
      Header: I18n.t('BEE1375' /* Quantidade de Etiquetas */),
      accessor: 'qtdLabelsToPrint',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <NumberFormat
            className="form-control"
            decimalScale={0}
            value={row.value}
            onValueChange={(values) => {
              let updatedValue = values.floatValue;
              if (row.value !== updatedValue) {
                updatedValue = updatedValue || 1;
                this.setState((prevState) => {
                  const { labelsToPrint, totalSelected } = prevState;

                  const currentLabel = labelsToPrint.find((label) => label.id === row.original.id);

                  if (currentLabel) {
                    const updatedLabelsToPrint = labelsToPrint.map((label) => (label.id === row.original.id
                      ? { ...label, qtdLabelsToPrint: updatedValue }
                      : label));

                    const newTotalSelected = totalSelected - currentLabel.qtdLabelsToPrint + updatedValue;

                    return {
                      labelsToPrint: updatedLabelsToPrint,
                      totalSelected: newTotalSelected,
                    };
                  }
                  return null;
                });
              }
            }}
            allowNegative={false}
            disabled={false}
            allowEmptyFormatting
          />
        </div>
      ),
    }, {
      Header: I18n.t('BEE4209' /* Quantidade da Embalagem */),
      accessor: 'qtdFractionalPackaging',
      style: { alignSelf: 'center', textAlign: 'center' },
      minWidth: 100,
      Cell: (row) => (
        <div style={{ textAlign: 'center' }}>
          <NumberFormat
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={!this.props.fractionalQuantity ? 0 : 4}
            value={row.value}
            onBlur={(values) => {
              const rawValue = values.target.value;
              let updatedValue = parseFloat(
                rawValue.replace(/\./g, '').replace(',', '.'),
              );
              if (row.value !== updatedValue) {
                updatedValue = updatedValue || 1;
                this.setState((prevState) => {
                  const { labelsToPrint } = prevState;

                  const currentLabel = labelsToPrint.find((label) => label.id === row.original.id);

                  if (currentLabel) {
                    const updatedLabelsToPrint = labelsToPrint.map((label) => (label.id === row.original.id
                      ? { ...label, qtdFractionalPackaging: updatedValue }
                      : label));

                    return {
                      labelsToPrint: updatedLabelsToPrint,
                    };
                  }
                  return null;
                });
              }
            }}
            allowNegative={false}
            fixedDecimalScale
            disabled={false}
          />
        </div>
      ),
    }];

    if (this.props.showAllColumnsDatatable) {
      if (!modalMode) {
        columns.splice(1, 0, {
          Header: I18n.t('BEE1027' /* Número do Documento */),
          accessor: 'orderNumber',
          style: { alignSelf: 'center', textAlign: 'center' },
          minWidth: 100,
        });
      }
      columns.splice(1, 0, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      });
      columns.splice(1, 0, {
        Header: '',
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 50,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <input
              type="checkbox"
              checked={this.state.checked[row.original.id] || false}
              onChange={() => this.singleSelection(row.original)}
            />
          </div>
        ),
      });
    }
    return columns;
  };

  closeModalPrintFractionalPackagingLabel = () => {
    this.setState({
      totalSelected: 0,
      qtdLabelsToPrint: 1,
      qtdFractionalPackaging: 1,
      labelsToPrint: [],
    });
    this.props.closeModalPrintFractionalPackagingLabel();
  };

  addFractionalPackagingLabel = async () => {
    const {
      qtdLabelsToPrint, qtdFractionalPackaging, totalSelected, labelsToPrint, productCode, orderNumber,
    } = this.state;

    const { modalMode } = this.props;

    if (qtdLabelsToPrint > 0 && qtdFractionalPackaging > 0 && ((!modalMode) ? !!productCode : true)) {
      const isDuplicate = labelsToPrint.some((label) => label.qtdLabelsToPrint === qtdLabelsToPrint
      && label.qtdFractionalPackaging === qtdFractionalPackaging
       && (productCode !== '' ? label.productCode === productCode : true)
       && label.orderNumber === orderNumber.trim());

      if (isDuplicate) {
        addNotification(
          'warning',
          I18n.t('BEE4196' /* Impressão de Etiquetas */),
          I18n.t('BEE4217' /* A impressão já foi incluída na lista */),
          'top-right',
        );
        return;
      }

      const newLabel = {
        productCode,
        orderNumber: orderNumber.trim(),
        qtdLabelsToPrint,
        qtdFractionalPackaging,
        id: labelsToPrint.length > 0 ? labelsToPrint[labelsToPrint.length - 1].id + 1 : 0,
      };
      this.setState({
        labelsToPrint: [...labelsToPrint, newLabel],
        totalSelected: parseInt(totalSelected, 10) + parseInt(qtdLabelsToPrint, 10),
      });
      this.setFormInitState();
    } else {
      addNotification(
        'danger',
        I18n.t('BEE4196' /* Impressão de Etiquetas */),
        I18n.t('BEE4342' /* Preencha todos os campos corretamente */),
        'top-right',
      );
    }
  };

  showDeleteLabelToPrint = (labelToPrint) => {
    this.setState({ showModalDelete: true, labelToPrintDelete: labelToPrint });
  };

  deleteLabelToPrint = async (labelToPrint) => {
    this.setFormInitState();
    try {
      this.setState((prevState) => ({
        labelsToPrint: prevState.labelsToPrint.filter((label, index) => index !== labelToPrint._index),
        totalSelected: prevState.totalSelected - labelToPrint.qtdLabelsToPrint,
      }));

      addNotification(
        'success',
        I18n.t('BEE4205' /* Eliminar Impressão */),
        I18n.t('BEE4206', { 0: labelToPrint._index + 1 } /* Impressão da etiqueta %{0} eliminada com sucesso! */),
        'top-right',
      );
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details}`
          : error.message;

        addNotification(
          'danger',
          I18n.t('BEE4205' /* Eliminar Impressão */),
          messageError,
          'top-right',
        );
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4205' /* Eliminar Impressão */),
          I18n.t('BEE1960' /* Erro ao gravar os dados */),
          'top-right',
        );
      }
    }
  };

  getUserPrinterOptions = async () => {
    const Info = await this.props.getUserPrinterOptions();
    const { userPrinter, printerOptions } = Info;
    const { printerSelected } = this.state;

    this.setState({
      printerOptions,
      printerSelected: (printerSelected === null
        ? userPrinter
        : printerSelected !== userPrinter
            && printerSelected)
             || userPrinter,
    });
  };

  hidePrinterDialog = () => {
    this.setState({
      showPrinterDialog: false,
      printerSelected: null,
    });
  };

  checkPrinters = () => {
    const {
      printerOptions,
      printerSelected,
    } = this.state;

    if (printerOptions.length === 0 && printerSelected === null) {
      addNotification(
        'danger',
        I18n.t('BEE4196' /* Impressão de Etiquetas */),
        I18n.t('BEE1415' /* Usuário não possui impressora relacionada */),
        'top-right',
      );
    } else if (printerOptions && printerOptions.length > 1) {
      this.setState({
        showPrinterDialog: true,
      });
    } else {
      this.printOut();
    }
  };

  printOut = async () => {
    const {
      showAllColumnsDatatable, inboundOrder, inboundOrderProduct, outboundOrder, outboundOrderProduct, modalMode,
    } = this.props;
    const {
      printerSelected, labelsToPrint, checkedLabelsToPrintIds,
    } = this.state;

    this.setState({
      showPrinterDialog: false, checked: {}, checkedLabelsToPrintIds: [],
    });

    try {
      const result = await this.props.printFractionalPackagingLabel(
        printerSelected,
        showAllColumnsDatatable ? checkedLabelsToPrintIds : labelsToPrint,
        inboundOrder ? inboundOrder.id : false,
        inboundOrderProduct ? inboundOrderProduct.id : false,
        outboundOrder ? outboundOrder.id : false,
        outboundOrderProduct ? outboundOrderProduct.id : false,
        false,
      );

      if (result && result.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE4196' /* Impressão de Etiquetas */),
          I18n.t('BEE1441' /* Erro ao tentar imprimir */),
          'top-right',
        );
      } else {
        addNotification(
          'success',
          I18n.t('BEE4196' /* Impressão de Etiquetas */),
          I18n.t('BEE1427' /* Etiquetas enviadas para impressora ! */),
          'top-right',
        );
        if (showAllColumnsDatatable) {
          this.setState((prevState) => ({
            labelsToPrint: prevState.labelsToPrint.filter(
              (label) => !checkedLabelsToPrintIds.includes(label),
            ),
            totalSelected: prevState.totalSelected - checkedLabelsToPrintIds.reduce(
              (acc, label) => acc + label.qtdLabelsToPrint,
              0,
            ),
          }));

          if (this.state.labelsToPrint.length === 0 && modalMode) {
            this.closeModalPrintFractionalPackagingLabel();
          }
        } else {
          this.setState({
            labelsToPrint: [],
            totalSelected: 0,
          });
        }
        if (modalMode) {
          this.setInitState();
        }
      }
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.message) {
        const messageError = (error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        addNotification('danger', I18n.t('BEE4196' /* Impressão de Etiquetas */), messageError, 'top-right');
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4196' /* Impressão de Etiquetas */),
          I18n.t('BEE1441' /* Erro ao tentar imprimir */),
          'top-right',
        );
      }
    }
  };

  singleSelection = (selection) => {
    const { checked } = this.state;
    checked[selection.id] = !checked[selection.id];
    this.setState({ checked: { ...checked } });
  };

  multipleSelection = (selectionOption) => {
    const { checked } = this.state;
    const data = this.reactTable.getResolvedState().sortedData;
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index += 1) {
        const element = data[index]._original;
        checked[element.id] = selectionOption;
      }
      this.setState({ checked: { ...checked } });
    }
  };

  validChecked = () => {
    const { checked, labelsToPrint } = this.state;
    if (!Object.keys(checked).length) {
      addNotification(
        'danger',
        I18n.t('BEE4196' /* Impressão de Etiquetas */),
        I18n.t('BEE4218' /* Nenhuma etiqueta selecionada */),
        'top-right',
      );
    } else {
      const checkedLabelsToPrintIds = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in checked) {
        if (Object.prototype.hasOwnProperty.call(checked, key)) {
          const labelToPrint = labelsToPrint.find((label) => label.id === parseInt(key, 10));
          if (checked[key] && labelToPrint) {
            checkedLabelsToPrintIds.push(labelToPrint);
          }
        }
      }
      if (checkedLabelsToPrintIds.length > 0) {
        this.setState({
          checkedLabelsToPrintIds: [...checkedLabelsToPrintIds],
        });
        this.checkPrinters();
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4196' /* Impressão de Etiquetas */),
          I18n.t('BEE4218' /* Nenhuma etiqueta selecionada */),
          'top-right',
        );
      }
    }
  };

  getProducts = async (inboundOrderId = false, outboundOrderId = false) => {
    let products = [];
    if (inboundOrderId) {
      products = await this.props.getListInboundOrderProducts(inboundOrderId);
    } else if (outboundOrderId) {
      products = await this.props.getListOutboundOrderProducts(outboundOrderId);
    }
    return products;
  };

  getFormData = async () => {
    const {
      inboundOrder, inboundOrderProduct, outboundOrder, outboundOrderProduct,
    } = this.props;

    let products = [];
    if (inboundOrder) {
      products = await this.getProducts(inboundOrder.id);
    } else if (inboundOrderProduct) {
      this.setState({
        unitMeasure: inboundOrderProduct.unitMeasure,
        materialFamily: inboundOrderProduct.materialFamily,
        qtdFractionalPackaging: parseFloat(inboundOrderProduct.quantity),
      });
    } else if (outboundOrder) {
      products = await this.getProducts(false, outboundOrder.id);
    } else if (outboundOrderProduct) {
      this.setState({
        unitMeasure: outboundOrderProduct.unitMeasure,
        materialFamily: outboundOrderProduct.materialFamily,
        qtdFractionalPackaging: parseFloat(outboundOrderProduct.quantity),
      });
    }

    if (products && products.length > 0) {
      const productRows = [];
      let labelId = 0;

      products.forEach((product) => {
        if (product.productLots && product.productLots.length > 0) {
          product.productLots.forEach((lot) => {
            productRows.push({
              id: labelId,
              inboundOrderProductId: product.inboundOrderProductId || product.id,
              outboundOrderProductId: product.outboundOrderProductId,
              productCode: product.productCode,
              lotNumber: lot.lotNumber || '',
              expirationDate: lot.expDate || null,
              mfgDate: lot.mfgDate || null,
              qtdLabelsToPrint: 1,
              qtdFractionalPackaging: parseFloat(lot.quantity),
            });
            labelId += 1;
          });
        } else {
          productRows.push({
            id: labelId,
            inboundOrderProductId: product.inboundOrderProductId || product.id,
            outboundOrderProductId: product.outboundOrderProductId,
            productCode: product.productCode,
            qtdLabelsToPrint: 1,
            qtdFractionalPackaging: parseFloat(product.quantity),
          });
          labelId += 1;
        }
      });

      this.setState({
        labelsToPrint: productRows,
        documentProducts: products,
        totalSelected: productRows.reduce((acc, row) => acc + row.qtdLabelsToPrint, 0),
      });
    } else {
      this.setState({ documentProducts: [] });
    }
  };

  renderQuantitiesForm = () => {
    const {
      qtdLabelsToPrint, qtdFractionalPackaging, unitMeasure, materialFamily,
    } = this.state;

    return (
      <div>

        <div className="d-flex" style={{ gap: '0.8rem' }}>
          <div className="flex-column" style={{ flexBasis: '30%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createInput(
                  unitMeasure,
                  'unitMeasure',
                  `${I18n.t('BEE1756' /* Unidade de Medida */)}:`,
                  '',
                  'text',
                  false,
                  true,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'p-2'],
                ),
              ])}
            />
          </div>
          <div className="flex-column" style={{ flexBasis: '70%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createInput(
                  materialFamily,
                  'materialFamily',
                  `${I18n.t('BEE2668' /* Família Material */)}:`,
                  '',
                  'text',
                  false,
                  true,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'p-2'],
                ),
              ])}
            />
          </div>
        </div>
        <div className="d-flex" style={{ gap: '0.8rem' }}>
          <div className="flex-column" style={{ flexBasis: '50%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createNumberFormat(
                  qtdLabelsToPrint,
                  'qtdLabelsToPrint',
                  `${I18n.t('BEE1375' /* Quantidade de Etiquetas */)}:`,
                  0,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'p-2'],
                  true,
                  undefined,
                  false,
                ),
              ])}
            />
          </div>
          <div className="flex-column" style={{ flexBasis: '50%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createNumberFormat(
                  qtdFractionalPackaging,
                  'qtdFractionalPackaging',
                  `${I18n.t('BEE4209' /* Quantidade da Embalagem */)}:`,
                  this.props.fractionalQuantity ? 4 : 0,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'p-2'],
                  true,
                  undefined,
                  false,
                ),
              ])}
            />
          </div>
          <div className="d-flex align-items-end">
            <OneClickButton
              type="button"
              className="btn btn-primary btn-120 m-b-3"
              onClick={() => this.addFractionalPackagingLabel()}
              disabled={qtdLabelsToPrint === undefined
               || qtdLabelsToPrint <= 0
               || qtdFractionalPackaging === undefined || qtdFractionalPackaging <= 0}
            >
              {I18n.t('BEE3992' /* Incluir etiqueta */)}
            </OneClickButton>
          </div>
        </div>
      </div>
    );
  };

  renderProductForm = () => {
    const {
      productCode, productName, listProduct, orderNumber,
    } = this.state;

    return (
      <div className="m-b-10">
        <div className="d-flex" style={{ gap: '0.8rem' }}>
          <div className="flex-column" style={{ flexBasis: '30%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createInput(
                  orderNumber,
                  'orderNumber',
                  `${I18n.t('BEE1027' /* Número do Documento */)}:`,
                  '',
                  'text',
                  false,
                  false,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'p-2'],
                ),
              ])}
            />
          </div>
        </div>
        <div className="d-flex" style={{ gap: '0.8rem' }}>
          <div className="flex-column" style={{ flexBasis: '30%' }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              setValueDrop={this.setValueDrop}
              setFilterDrop={this.setFilterDrop}
              inputs={(formContext) => ([
                formContext.createSelectDropDownFilter(
                  { code: productCode, label: productName },
                  'product',
                  `${I18n.t('BEE225' /* Produto */)}:`,
                  listProduct,
                  false,
                  ['col-form-label', 'div', 'p-2'],
                  true,
                ),
              ])}
            />
          </div>
          <div className="flex-column" style={{ flexBasis: '70%', paddingTop: 34 }}>
            <Form
              noPanel
              leftType
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createInput(
                  productName,
                  'productName',
                  '',
                  '',
                  'text',
                  false,
                  true,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  ['div', 'col-form-label', 'div'],
                ),
              ])}
            />
          </div>
        </div>
      </div>
    );
  };

  renderForm = () => {
    const {
      showProductForm, showQuantitiesForm, labelsToPrint, totalSelected, defaultPageSize, pageSizeOptions,
    } = this.state;

    const { modalMode, showAllColumnsDatatable } = this.props;

    const marginTop = !modalMode || (modalMode && !showAllColumnsDatatable) ? 30 : 0;

    return (
      <div>
        <div>
          <div onSubmit={(e) => e.preventDefault()}>
            {showProductForm && this.renderProductForm()}
            {showQuantitiesForm && this.renderQuantitiesForm()}
          </div>
        </div>
        <div style={{ marginLeft: -15, marginRight: -15, marginTop: marginTop + 8 }}>
          <Table
            ref={(r) => {
              this.reactTable = r && r.reactTable;
            }}
            actionButtons={(
              (totalSelected > 0 && showAllColumnsDatatable) && (
                <div className="ml-auto mb-1">
                  <button
                    type="button"
                    className="btn btn-120 btn-secondary p-5 m-5"
                    onClick={() => this.multipleSelection(true)}
                  >
                    {I18n.t('BEE1908' /* Marcar Todos */)}
                  </button>
                  <button
                    type="button"
                    className="btn btn-120 btn-secondary p-5 m-5"
                    onClick={() => this.multipleSelection(false)}
                  >
                    {I18n.t('BEE1909' /* Desmarcar Todos */)}
                  </button>
                  <OneClickButton
                    type="button"
                    className="btn btn-120 btn-primary p-5 m-5"
                    onClick={() => this.validChecked()}
                  >
                    {I18n.t('BEE1270' /* Imprimir */)}
                  </OneClickButton>
                </div>
              )
            )}
            panelHeaderProps={{
              noButton: true,
              children: I18n.t('BEE1371' /* Etiquetas */).toUpperCase(),
            }}
            filterable
            data={labelsToPrint}
            columns={this.tableColumns}
            expander
            pageSizeOptions={pageSizeOptions}
            defaultPageSize={defaultPageSize}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
          />
        </div>
        <div className="row align-items-center">
          <label htmlFor="totalSelected" className="col-form-label f-s-16 f-w-700 m-l-5 mr-2">
            {I18n.t('BEE4203' /* Total de Impressões */)}
            :
            {' '}
          </label>
          <div>
            <input
              id="totalSelected"
              className="form-control text-center f-s-14"
              type="text"
              value={totalSelected}
              readOnly
            />
          </div>
          {!showAllColumnsDatatable && (
            <div className="ml-auto">
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={() => this.checkPrinters()}
                disabled={totalSelected <= 0}
              >
                {I18n.t('BEE1270' /* Imprimir */)}
              </OneClickButton>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const {
      showModalDelete, labelToPrintDelete, printerOptions, showPrinterDialog,
      printerSelected,
    } = this.state;
    const {
      openChangeModal = false, modalMode = false, breadcrumb = false, title = '', wikiHelp = false, noButton = false,
    } = this.props;

    return (
      <div>
        {modalMode ? (
          <Modal
            size="lg"
            isOpen={openChangeModal}
            toggle={() => this.closeModalPrintFractionalPackagingLabel()}
          >
            <ModalHeader
              toggle={() => this.closeModalPrintFractionalPackagingLabel()}
            >
              {I18n.t(
                'BEE4220',
                { 0: I18n.t('BEE4202' /* Etiquetas de Embalagem Fracionada */) }, /* Impressão de %{0} */
              ).toLocaleUpperCase()}
            </ModalHeader>
            <ModalBody>
              {this.renderForm()}
            </ModalBody>
          </Modal>
        ) : (
          <PanelPage
            breadcrumb={breadcrumb}
            noButton={noButton}
            title={title}
            wikiHelp={wikiHelp}
            content={(
              this.renderForm()
            )}
            noFooter
          />
        )}
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteLabelToPrint(labelToPrintDelete)}
              onCancel={() => this.setFormInitState()}
            >
              {I18n.t(
                'BEE4204',
                { 0: labelToPrintDelete._index + 1 }, /* A impressão da etiqueta %{0} será eliminada! */
              )}
            </SweetAlert>
          )
        )}
        {(showPrinterDialog && (
        <SweetAlert
          confirmBtnText={I18n.t('BEE436' /* Selecionar */)}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          title={I18n.t('BEE1324' /* Selecionar Impressora */)}
          onConfirm={() => this.printOut()}
          onCancel={() => this.hidePrinterDialog()}
        >
          <div className="mt-4">
            <Form
              noPanel
              setValue={this.setValue}
              inputs={(formContext) => ([
                formContext.createSelect(
                  printerSelected,
                  'printerSelected',
                  I18n.t('BEE328' /* Impressora */),
                  printerOptions,
                  '',
                  '',
                  12,
                  true,
                ),
              ])}
            />
          </div>
        </SweetAlert>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fractionalQuantity: state.app.permissionsCompany && state.app.permissionsCompany.fractionalQuantity,
});

const mapDispatchToProps = (dispatch) => ({
  getUserPrinterOptions: () => dispatch(getUserPrinterOptions()),
  printFractionalPackagingLabel: (
    printerCode,
    checkedLabelsToPrintIds,
    inboundOrderId,
    inboundOrderProductId,
    outboundOrderId,
    outboundOrderProductId,
    fromConference,
  ) => dispatch(printFractionalPackagingLabel(
    printerCode,
    checkedLabelsToPrintIds,
    inboundOrderId,
    inboundOrderProductId,
    outboundOrderId,
    outboundOrderProductId,
    fromConference,
  )),
  getOptionsProductsLimit: (productFilter) => dispatch(getOptionsProductsLimit(productFilter)),
  getListInboundOrderProducts: (inboundOrderId) => dispatch(getListInboundOrderProducts(inboundOrderId)),
  getListOutboundOrderProducts: (outboundOrderId) => dispatch(getListOutboundOrderProducts(outboundOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrintFractionalPackagingLabel));
